export default __webpack_public_path__ + "static/media/Screen Shot 2021-02-26 at 7.56.24 PM.ed63560c.png";